<template>
    <div class="site-static-content leading-relaxed" v-html="pageContent"></div>
</template>
<script setup lang="ts">
const { locale } = useI18n();

const { file } = defineProps<{ file: string }>();

const { data: pageContent } = await useFetch(`/content/${locale.value}/${file}`);
</script>
<style>
.site-static-content {
    ul {
        list-style: disc;
        margin-left: calc(var(--spacing) * 8);
    }
    h2,
    p {
        margin-bottom: calc(var(--spacing) * 6);
    }
    h3 {
        margin: calc(var(--spacing) * 4) 0;
    }
}
</style>
